var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "black",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 12.0005H12.9999C11.3432 12.0005 9.99988 13.3438 9.99988 15.0005V27.0005C9.99988 28.6572 11.3432 30.0005 12.9999 30.0005H28.9999C30.6566 30.0005 31.9999 28.6572 31.9999 27.0005V15.0005C31.9999 13.3438 30.6566 12.0005 28.9999 12.0005ZM28.9999 14.0005C29.1154 14.0005 29.2264 14.02 29.3294 14.0562L20.9999 20.72L12.6704 14.0562C12.7763 14.0191 12.8877 14.0003 12.9999 14.0005H28.9999ZM28.9999 28.0005H12.9999C12.7347 28.0005 12.4803 27.8951 12.2928 27.7076C12.1053 27.5201 11.9999 27.2657 11.9999 27.0005V16.081L20.3751 22.7813C20.5576 22.9275 20.7787 23.0005 20.9999 23.0005C21.2211 23.0005 21.4422 22.9275 21.6247 22.7813L29.9999 16.081V27.0005C29.9999 27.2657 29.8945 27.5201 29.707 27.7076C29.5195 27.8951 29.2651 28.0005 28.9999 28.0005Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFEmail);
export default __webpack_public_path__ + "static/media/f-email.f17610246cae6defdf355892cf277448.svg";
export { ForwardRef as ReactComponent };